import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _get from 'lodash/get'
import { useSelector } from 'react-redux'
import { selectStaticTextByKey } from 'services/static-text/selectors'
import { selectPlansBySku } from 'services/plans/selectors'
import { getPlanSkus } from 'services/plans'
import Button, { TYPES } from 'components/Button'
import { selectGiftSku } from 'services/gift/selectors'
import { selectPrimaryLanguage } from 'services/user/selectors'
import { getPlanDetails, useNextGiftRoute } from 'services/gift/utils'
import { get as getConfig } from 'config'
import { GIFT_PLAN_SELECT_KEY } from './gift-plan-select-key'

const giftPlansSku = getPlanSkus({ isGift: true })
const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

export const GiftPlanGrid = (props) => {
  const { planData } = props
  const staticText = useSelector(selectStaticTextByKey(GIFT_PLAN_SELECT_KEY))
  let giftPlans = useSelector(selectPlansBySku(giftPlansSku))
  const activeSku = useSelector(selectGiftSku)
  const userLanguage = useSelector(selectPrimaryLanguage)
  const getNextRoute = useNextGiftRoute()

  if (planGraphQLActive) {
    giftPlans = planData
  }

  return (
    <ul className="gift-plan-grid">
      {giftPlans.map((plan) => {
        const {
          details: { price, planName, valuePropositions },
        } = getPlanDetails(plan, userLanguage)
        return (
          <li className="gift-plan-grid__item" key={plan.get('sku')}>
            <div
              className="gift-plan-option__content"
              data-testid="gift-plan-option"
            >
              <div className="gift-plan-option__content-body">
                <div className="gift-plan-option__header">
                  <div className="gift-plan-option__header-title">
                    {planName}
                  </div>
                  <div className="gift-plan-option__price">{price}</div>
                </div>
                <ul className="gift-plan-option__values-list">
                  {valuePropositions.map((value) => (
                    <li className="gift-plan-option__value" key={value}>
                      {value}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="gift-plan-option__content-footer">
                {activeSku === plan.get('sku') ? (
                  <Button
                    className="gift-plan-option__btn gift-plan-option__btn--disabled"
                    type={TYPES.SECONDARY}
                    disabled
                  >{staticText.get('current')}
                  </Button>
                ) : (
                  <Button
                    className="gift-plan-option__btn"
                    type={TYPES.PRIMARY}
                    url={getNextRoute({ sku: plan.get('sku') })}
                  >{staticText.get('select')}
                  </Button>
                )}
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

GiftPlanGrid.propTypes = {
  location: PropTypes.object,
  planData: ImmutablePropTypes.list,
}

export default GiftPlanGrid
